// extracted by mini-css-extract-plugin
module.exports = {"radio":"jgp-a1cl4"};